import { takeLatest, call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';
import get from 'lodash/get';

import * as Actions from './actions';
import * as Api from './api';
import * as Constants from './constants';
import * as Mappers from './mappers';
import * as Types from './types';

export function* List(action: ReturnType<typeof Actions.List.request>) {
  const { callback } = action.payload;
  try {
    const {
      data
    }: AxiosResponse<{
      data?: { documents: Types.IApi.Document[] };
      documents?: Types.IApi.Document[];
    }> = yield call(Api.List);
    const rawDocuments = get(data, 'data.documents') ?? get(data, 'documents') ?? [];
    const items = Mappers.documentList(rawDocuments);
    yield put(Actions.List.success({ items }));
    if (callback?.onSuccess) {
      yield call(callback.onSuccess, { items });
    }
  } catch (error) {
    const errorResponse = error as AxiosError;
    const errorMessage = (errorResponse?.response?.data as any)?.message ?? 'Unknown error';
    yield put(Actions.List.failure({ error: errorMessage }));
    if (callback?.onError) {
      yield call(callback.onError, errorMessage);
    }
  } finally {
    if (callback?.onFinally) {
      yield call(callback.onFinally);
    }
  }
}

export default function* root() {
  yield takeLatest(Constants.LIST.REQUEST, List);
}
